import type { Transport } from "./api";

/** Raw response headers ("Name: value" lines) as Headers. */
export function parseHeaders(raw: string): Headers {
  const headers = new Headers();
  for (const line of raw.split(/\r?\n/)) {
    const at = line.indexOf(":");
    if (at > 0) headers.append(line.slice(0, at).trim(), line.slice(at + 1).trim());
  }
  return headers;
}

/** A Transport over XMLHttpRequest for the one thing fetch cannot do: report upload progress (0 to 1). The body goes
 * whole, with its Content-Length (uploadFile answers 411 without one). */
export function xhrTransport(onProgress: (fraction: number) => void, make: () => XMLHttpRequest = () => new XMLHttpRequest()): Transport {
  return (url, init) =>
    new Promise<Response>((resolve, reject) => {
      const xhr = make();
      xhr.open(init.method ?? "GET", url);
      new Headers(init.headers).forEach((value, name) => xhr.setRequestHeader(name, value));
      xhr.responseType = "arraybuffer";
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable && event.total > 0) onProgress(event.loaded / event.total);
      };
      xhr.onload = () => {
        const empty = xhr.status === 204 || xhr.status === 205 || xhr.status === 304;
        resolve(new Response(empty ? null : (xhr.response as ArrayBuffer), { status: xhr.status, headers: parseHeaders(xhr.getAllResponseHeaders()) }));
      };
      xhr.onerror = () => reject(new TypeError("Network request failed"));
      xhr.onabort = () => reject(new DOMException("The upload was stopped.", "AbortError"));
      xhr.send((init.body ?? null) as XMLHttpRequestBodyInit | null);
    });
}
